"use client";

import { Plus } from "geist-icons";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import { SquareFrameVercel } from "./square-grid-vercel";
import dynamic from "next/dynamic";
import { Skeleton } from "@/components/ui/skeleton";

const VercelScene = dynamic(() => import("../vercel/scene/vercel-scene"), {
  ssr: false,
});
VercelScene;

export default function VercelHome() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <section className="w-full bg-[#FAFAFA] dark:bg-black min-w-[320px] flex items-center justify-center px-4 sm:px-6 md:px-8 lg:px-10">
      {/* Wrapper to control the width of the grid */}
      <div className="relative z-20 w-full max-w-[1100px]">
        {/* Grid container with fixed height classes */}
        <div className="relative z-50 w-full h-[550px] sm:h-[650px] md:h-[810px] lg:h-[950px] border-l-2 border-r-2 border-[#EAEAEA] dark:border-[#1E1E1E] flex flex-col mx-auto">
          <div className="absolute z-30 lg:top-[68px] md:top-[58px] top-[58px] sm:top-[70px] md:-right-[11px] -right-[11px] flex items-center justify-center">
            <Plus className="text-[#A8A8A8] dark:text-[#878787] scale-100 md:scale-130" />
          </div>
          <SquareFrameVercel>
            <div className="relative h-full">
              <div className="mt-12 sm:mt-14 md:mt-12 lg:mt-20">
                <div className="flex flex-row ml-3.5 md:ml-5">
                  <h1 className="relative lg:text-6xl md:text-5xl text-4xl mt-10 mr-5 font-bold">
                    Vercel
                  </h1>
                  <h4 className="lg:text-4xl md:text-2xl text-xl mt-12.5 md:mt-14 lg:mt-15 font-bold">
                    for peak performance
                  </h4>
                </div>
                <div className="flex flex-row md:gap-10 gap-5 mt-3 ml-4 md:ml-6">
                  <Link href="/tools" className="underline">
                    Look at my tools
                  </Link>
                </div>
              </div>
            </div>
          </SquareFrameVercel>

          <div className="absolute flex inset-0 top-50 sm:top-45 md:top-60 h-[60%] sm:h-[70%] w-full overflow-visible">
            {mounted ? (
              <>
                <VercelScene />

                <div className="absolute top-0 left-0 w-full h-10 md:h-20 lg:h-30 bg-linear-to-b from-[#FAFAFA] via-[#FAFAFA] to-transparent dark:from-black dark:via-black pointer-events-none z-40" />

                <div className="absolute top-0 left-0 h-full w-5 sm:w-10 md:w-20 lg:w-30 bg-linear-to-r from-[#FAFAFA] via-[#FAFAFA] to-transparent dark:from-black dark:via-black pointer-events-none z-40" />
                <div className="absolute top-0 right-0 h-full w-5 sm:w-10 md:w-20 lg:w-30 bg-linear-to-l from-[#FAFAFA] via-[#FAFAFA] to-transparent dark:from-black dark:via-black pointer-events-none z-40" />

                <div className="absolute bottom-0 left-0 w-full h-10 md:h-20 lg:h-30 bg-linear-to-t from-[#FAFAFA] via-[#FAFAFA] to-transparent dark:from-black dark:via-black pointer-events-none z-40" />
              </>
            ) : (
              <Skeleton className="flex w-full h-full rounded-none" />
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
